module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/main-view_92b0f657eb3b2a5704bc88df220d7e2b.png";